export default "__VITE_ASSET__DuxM3Ps7__"